export default "__VITE_ASSET__CilcjJt8__"